<template>
  <div class="devicetest-bd tb" v-if="funcView.battery_management_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item style="float: right; margin-right: 0">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- <el-form-item style="float: right" v-if="funcView.battery_management_export">
          <el-button class="table-set" style="vertical-align: top" @click="exportTable('modemBatteryExport', formSearch)">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item> -->
        <el-form-item style="float: right">
          <search-input :placeholder="$t('dms_batteryManagement.dcSNModemSNcpSN')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
        <el-radio-group style="float: right; margin-right: 8px" v-model="formSearch.btQueryType" @change="onPageChange({ page: 1 })">
          <el-radio-button :label="item.value" v-for="(item, index) in btQueryTypeData" :key="index">{{ item.label }}</el-radio-button>
        </el-radio-group>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('dms_batteryManagement.ISTzhan_dian')">
          <custom-select
            v-model="formSearch.websiteName"
            filterable
            url="websiteSelectList"
            :model="formSearch"
            :params="{ websiteEnv: this.websiteEnv, websiteType: 1 }"
            :props="{ label: 'websiteName', value: 'websiteName', map: { websiteCode: 'websiteCode' } }"
            width="100%"
          ></custom-select>
        </el-form-item>
        <el-form-item :label="$t('dms_batteryManagement.chan_pin_xing_hao')">
          <custom-select
            url="productCodeSelectList"
            v-model="formSearch.productCode"
            :listener="formSearch.websiteCode"
            :params="{ websiteCode: formSearch.websiteCode }"
            :props="{ label: 'productCode', value: 'productCode' }"
            width="100%"
          ></custom-select>
        </el-form-item>

        <el-form-item :label="$t('dms_batteryManagement.xie_yi')">
          <el-input v-model="formSearch.protocolCode" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_batteryManagement.sheng_yu_dian_liang')">
          <input-range v-model="formSearch.batteryCharge" type="number" style="width: 100%" />
        </el-form-item>
        <el-form-item label="SOH">
          <input-range v-model="formSearch.soh" type="number" style="width: 100%" />
        </el-form-item>
        <el-form-item :label="$t('dms_batteryManagement.xun_huan_ci_shu')">
          <input-range v-model="formSearch.batteryCycleCount" type="number" style="width: 100%" />
        </el-form-item>
        <el-form-item :label="$t('dms_batteryManagement.geng_xin_shi_jian')">
          <custom-date-picker style="width: 100%" v-model="formSearch.dataTimes" type="daterange" value-format="YYYY-MM-DD HH:mm:ss" :picker-options="beforeToday"></custom-date-picker>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table height="100%" :index="true" :data="tableList" :column="tableColumn" @sort="sortChange" @filter="filterChange" :slots="['batterySn', 'protocolCode', 'action']">
        <template slot="batterySn" slot-scope="scope">
          <span
            v-if="funcView.battery_management_board_detail"
            class="cell-link"
            @click="
              jump('/redirect/boarddetail', {
                deviceId: scope.row.deviceId,
                type: 'batteryManagement',
                testType: formSearch.testType,
                modemSn: scope.row.modemSn,
                batterySn: scope.row.batterySn,
                parentPath: $route.path,
              })
            "
          >
            {{ scope.row.batterySn }}
            <!-- {{scope.row.modemSn}} -->
          </span>
          <span v-else>{{ scope.row.batterySn }}</span>
        </template>
        <template slot="protocolCode" slot-scope="scope">
          <span>{{ scope.row.protocolCode || '-' }}/{{ scope.row.tcpVersion || '-' }}</span>
        </template>
        <template slot="action" slot-scope="scope">
          <el-button type="text" size="mini" v-if="[0, 1].includes(formSearch.btQueryType) && funcView.battery_management_scrap" @click="onScrap(scope.row)">
            {{ funcView.battery_management_scrap }}
          </el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';
import inputRange from '@/components/inputRange';

export default {
  mixins: [resetFormSearchMixins],
  name: 'batteryManagement',
  components: {
    inputRange,
  },
  computed: {
    btQueryTypeData() {
      return [
        {
          label: this.$t('dms_batteryManagement.wbdsb'),
          value: 0,
        },
        {
          label: this.$t('dms_batteryManagement.yi_bang_ding_she_bei'),
          value: 1,
        },
        {
          label: this.$t('dms_batteryManagement.yi_bao_fei'),
          value: 2,
        },
      ];
    },
  },
  data() {
    return {
      provide: true,
      tableCode: 'battery_management',

      formSearch: {
        btQueryType: 0,
        testType: 1,
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
        productCode: '',
        beginOfModified: '',
        endOfModified: '',
        dataTimes: '',
        websiteName: '',
        websiteCode: '',
        protocolCode: '',
        batteryCharge: [],
        beginOfBatteryCharge: '',
        endOfBatteryCharge: '',
        soh: [],
        beginOfSoh: '',
        endOfSoh: '',
        batteryCycleCount: [],
        beginOfBatteryCycleCount: '',
        endOfBatteryCycleCount: '',
      },
      tableList: [],
      totalRows: 0,
      dialogVisible: false,
      dialogModel: {},
      link: null,
    };
  },
  activated: function () {
    this.getTableList();
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

    this.getTableColumn();
  },
  methods: {
    // 获取列表
    getTableList() {
      this.formSearch.beginOfModified = this.formSearch.dataTimes ? this.formSearch.dataTimes[0] : '';
      this.formSearch.endOfModified = this.formSearch.dataTimes ? this.formSearch.dataTimes[1] : '';
      this.formSearch.beginOfBatteryCharge = this.formSearch.batteryCharge ? this.formSearch.batteryCharge[0] : '';
      this.formSearch.endOfBatteryCharge = this.formSearch.batteryCharge ? this.formSearch.batteryCharge[1] : '';
      this.formSearch.beginOfSoh = this.formSearch.soh ? this.formSearch.soh[0] : '';
      this.formSearch.endOfSoh = this.formSearch.soh ? this.formSearch.soh[1] : '';
      this.formSearch.beginOfBatteryCycleCount = this.formSearch.batteryCycleCount ? this.formSearch.batteryCycleCount[0] : '';
      this.formSearch.endOfBatteryCycleCount = this.formSearch.batteryCycleCount ? this.formSearch.batteryCycleCount[1] : '';
      this.$getJSON(apis.modemBatteryPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 测试
    onScrap(row) {
      const tips = this.$t('dms_batteryManagement.nqdybfxzddcm');
      this.$showConfirm(tips).then(() => {
        this.$postJSON(`${apis.modemBatteryScrapped}/${row.modemBatteryId}`).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.getTableList();
        });
      });
    },
  },
};
</script>
